"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableTableBody = exports.DraggableTable = exports.DragContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var get_element_offset_1 = require("../../../_util/get-element-offset");
var merge_refs_1 = require("../../../_util/merge-refs");
/**
 * 拖拽 Context 实例
 */
exports.DragContext = react_1.createContext({});
exports.DragContext.displayName = "DragContext";
function DraggableTable(_a) {
    var table = _a.table, draggableColumns = _a.draggableColumns, onDragEnd = _a.onDragEnd, columns = _a.columns, props = tslib_1.__rest(_a, ["table", "draggableColumns", "onDragEnd", "columns"]);
    var _b = tslib_1.__read(react_1.useState(""), 2), draggingColumn = _b[0], setDraggingColumn = _b[1];
    var _c = tslib_1.__read(react_1.useState({}), 2), columnClassNames = _c[0], setColumnClassNames = _c[1];
    var _d = tslib_1.__read(react_1.useState(0), 2), mouseStartX = _d[0], setMouseStartX = _d[1];
    var bodyRef = react_1.useRef(null);
    var bodyMaskRef = react_1.useRef(null);
    var bodyLineRef = react_1.useRef(null);
    function addColumnClassNames(column, className) {
        setColumnClassNames(function (preState) {
            if (preState[column] && Array.isArray(preState[column])) {
                var classNameSet = new Set(preState[column]);
                classNameSet.add(className);
                preState[column] = tslib_1.__spread(classNameSet);
            }
            else {
                preState[column] = [className];
            }
            return tslib_1.__assign({}, preState);
        });
    }
    function deleteColumnClassNames(className) {
        setColumnClassNames(function (preState) {
            for (var column in preState) {
                if (preState[column] && Array.isArray(preState[column])) {
                    var classNameSet = new Set(preState[column]);
                    classNameSet.delete(className);
                    preState[column] = tslib_1.__spread(classNameSet);
                }
                else {
                    preState[column] = [];
                }
            }
            return tslib_1.__assign({}, preState);
        });
    }
    var dragEventHandlers = {
        onDragStart: function (event) {
            event.stopPropagation();
            // QQ 浏览器设置 text 不触发 drop
            // event.dataTransfer.setData("text", "text");
            event.dataTransfer.setData("image/png", "img");
            event.dataTransfer.effectAllowed = "move";
            var dragImage = document.createElement("div");
            dragImage.style.width = "1px";
            dragImage.style.height = "1px";
            dragImage.style.backgroundColor = "#ebeef2";
            dragImage.style.position = "absolute";
            dragImage.style.top = "-1000px";
            document.body.appendChild(dragImage);
            if ("setDragImage" in event.dataTransfer) {
                event.dataTransfer.setDragImage(dragImage, 0, 0);
            }
            // 添加拖拽选择样式
            var draggingColumn = event.currentTarget.attributes.getNamedItem("data-column").value;
            setDraggingColumn(draggingColumn);
            addColumnClassNames(draggingColumn, "is-dragging");
            // 展示遮罩层
            var maskWith = event.currentTarget.clientWidth;
            var currentElementOffset = get_element_offset_1.getElementOffset(event.currentTarget);
            var tableElementOffset = get_element_offset_1.getElementOffset(bodyRef.current);
            requestAnimationFrame(function () {
                bodyMaskRef.current.style.display = "block";
                bodyMaskRef.current.style.transform = "translate3d(" + (currentElementOffset.left -
                    tableElementOffset.left) + "px, 0px, 0px)";
                bodyMaskRef.current.style.width = maskWith + "px";
            });
            setMouseStartX(event.pageX);
        },
        onDrag: function (event) {
            event.stopPropagation();
            var tableElementOffset = get_element_offset_1.getElementOffset(bodyRef.current);
            var currentElementOffset = get_element_offset_1.getElementOffset(event.currentTarget);
            var left = currentElementOffset.left -
                tableElementOffset.left +
                (event.pageX - mouseStartX);
            requestAnimationFrame(function () {
                bodyMaskRef.current.style.transform = "translate3d(" + left + "px, 0px, 0px)";
            });
        },
        onDragEnd: function (event) {
            requestAnimationFrame(function () {
                bodyMaskRef.current.style.display = "none";
                bodyMaskRef.current.style.transform = "translate3d(0px, 0px, 0px)";
                bodyLineRef.current.style.display = "none";
                bodyLineRef.current.style.transform = "translate3d(0px, 0px, 0px)";
                setMouseStartX(0);
                deleteColumnClassNames("is-dragging");
                deleteColumnClassNames("is-draggable");
                setDraggingColumn("");
            });
        },
        onDragEnter: function (event) {
            event.preventDefault();
        },
        onDragOver: function (event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = "move";
            var dropColumn = event.currentTarget.attributes.getNamedItem("data-column").value;
            var dropIndex = columns.findIndex(function (item) { return item.key === dropColumn; });
            var dragIndex = columns.findIndex(function (item) { return item.key === draggingColumn; });
            var dropElementOffset = get_element_offset_1.getElementOffset(event.currentTarget);
            var tableElementOffset = get_element_offset_1.getElementOffset(bodyRef.current);
            // 固定列/ignore列不作排序
            if (!columns[dropIndex] ||
                (columns[dropIndex] && columns[dropIndex].fixed)) {
                return;
            }
            if (dropIndex <= dragIndex) {
                requestAnimationFrame(function () {
                    bodyLineRef.current.style.display = "block";
                    bodyLineRef.current.style.transform = "translate3d(" + (dropElementOffset.left -
                        tableElementOffset.left) + "px, 0px, 0px)";
                });
                return;
            }
            bodyLineRef.current.style.display = "block";
            var leftValue = dropElementOffset.left -
                tableElementOffset.left +
                event.currentTarget.clientWidth;
            if (leftValue > bodyRef.current.clientWidth - 2) {
                leftValue = bodyRef.current.clientWidth - 2;
            }
            requestAnimationFrame(function () {
                bodyLineRef.current.style.transform = "translate3d(" + leftValue + "px, 0px, 0px)";
            });
        },
        onDragLeave: function (event) {
            event.preventDefault();
        },
        onDrop: function (event) {
            event.preventDefault();
            if (!draggingColumn) {
                return;
            }
            var dropColumn = event.currentTarget.attributes.getNamedItem("data-column").value;
            var dropIndex = columns.findIndex(function (item) { return item.key === dropColumn; });
            var dragIndex = columns.findIndex(function (item) { return item.key === draggingColumn; });
            if (dropIndex === dragIndex) {
                return;
            }
            // 固定列/ignore列不作排序
            if (!columns[dropIndex] ||
                (columns[dropIndex] && columns[dropIndex].fixed)) {
                return;
            }
            if (columns) {
                var newColumns = tslib_1.__spread(columns);
                newColumns.splice(dropIndex, 0, newColumns.splice(dragIndex, 1)[0]);
                onDragEnd(newColumns);
            }
        },
        onMouseEnter: function (event) {
            var targetColumn = event.currentTarget.attributes.getNamedItem("data-column").value;
            addColumnClassNames(targetColumn, "is-hover");
        },
        onMouseLeave: function (event) {
            deleteColumnClassNames("is-hover");
        },
    };
    var dragContext = {
        bodyRef: bodyRef,
        setBodyRef: function (body) {
            bodyRef.current = body;
        },
        bodyMaskRef: bodyMaskRef,
        setBodyMaskRef: function (bodyMask) {
            bodyMaskRef.current = bodyMask;
        },
        bodyLineRef: bodyLineRef,
        setBodyLineRef: function (bodyLine) {
            bodyLineRef.current = bodyLine;
        },
        dragEventHandlers: dragEventHandlers,
        draggableColumns: draggableColumns,
        columns: columns,
        draggingColumn: draggingColumn,
        setDraggingColumn: setDraggingColumn,
        columnClassNames: columnClassNames,
    };
    return (react_1.default.createElement(exports.DragContext.Provider, { value: dragContext }, react_1.default.cloneElement(table, {
        className: classnames_1.default(table.props.className, props.className),
    })));
}
exports.DraggableTable = DraggableTable;
exports.DraggableTableBody = react_1.forwardRef(function (_a, ref) {
    var body = _a.body, onDragEnd = _a.onDragEnd;
    var bodyRef = react_1.useRef(null);
    var _b = react_1.useContext(exports.DragContext), setBodyRef = _b.setBodyRef, setBodyMaskRef = _b.setBodyMaskRef, setBodyLineRef = _b.setBodyLineRef, bodyLineRef = _b.bodyLineRef, columns = _b.columns, draggingColumn = _b.draggingColumn;
    var getHoverTdNode = function (event) {
        var currentTd = null;
        var trs = Array.prototype.slice.call(bodyRef.current.getElementsByTagName("tr"), 0);
        var tds = trs && trs.length > 0
            ? Array.prototype.slice.call(trs[0].childNodes, 0)
            : [];
        if (tds && tds.length > 0) {
            var len = tds.length;
            for (var i = 0; i < len; i++) {
                var currentElementOffset = get_element_offset_1.getElementOffset(tds[i]);
                if (currentElementOffset.left < event.pageX &&
                    event.pageX < currentElementOffset.left + tds[i].clientWidth) {
                    currentTd = tds[i];
                    break;
                }
            }
        }
        return currentTd;
    };
    /**
     * 挂在遮罩层的事件处理器
     * 当鼠标移动到table的body区域的遮罩层时，需重新计算插入位置和样式
     */
    var maskDragEventHandlers = {
        onDragEnter: function (event) {
            event.preventDefault();
        },
        onDragOver: function (event) {
            event.preventDefault();
            var currentTd = getHoverTdNode(event);
            var dataColumnNode = currentTd && currentTd.attributes.getNamedItem("data-column");
            if (dataColumnNode) {
                var dropColumn_1 = dataColumnNode.value;
                var dropIndex = columns.findIndex(function (item) { return item.key === dropColumn_1; });
                var dropElementOffset_1 = get_element_offset_1.getElementOffset(currentTd);
                var tableElementOffset_1 = get_element_offset_1.getElementOffset(bodyRef.current);
                var dragIndex = columns.findIndex(function (item) { return item.key === draggingColumn; });
                // 固定列/ignore列不作排序
                if (!columns[dropIndex] ||
                    (columns[dropIndex] && columns[dropIndex].fixed)) {
                    return;
                }
                if (dropIndex <= dragIndex) {
                    requestAnimationFrame(function () {
                        bodyLineRef.current.style.display = "block";
                        bodyLineRef.current.style.transform = "translate3d(" + (dropElementOffset_1.left -
                            tableElementOffset_1.left) + "px, 0px, 0px)";
                    });
                    return;
                }
                bodyLineRef.current.style.display = "block";
                var leftValue_1 = dropElementOffset_1.left -
                    tableElementOffset_1.left +
                    currentTd.clientWidth;
                if (leftValue_1 > bodyRef.current.clientWidth - 2) {
                    leftValue_1 = bodyRef.current.clientWidth - 2;
                }
                requestAnimationFrame(function () {
                    bodyLineRef.current.style.transform = "translate3d(" + leftValue_1 + "px, 0px, 0px)";
                });
            }
        },
        onDrop: function (event) {
            event.preventDefault();
            var currentTd = getHoverTdNode(event);
            var dataColumnNode = currentTd && currentTd.attributes.getNamedItem("data-column");
            if (dataColumnNode) {
                var dropColumn_2 = dataColumnNode.value;
                var dropIndex = columns.findIndex(function (item) { return item.key === dropColumn_2; });
                var dragIndex = columns.findIndex(function (item) { return item.key === draggingColumn; });
                if (dropIndex === dragIndex) {
                    return;
                }
                // 固定列/ignore列不作排序
                if (!columns[dropIndex] ||
                    (columns[dropIndex] && columns[dropIndex].fixed)) {
                    return;
                }
                if (columns) {
                    var newColumns = tslib_1.__spread(columns);
                    newColumns.splice(dropIndex, 0, newColumns.splice(dragIndex, 1)[0]);
                    onDragEnd(newColumns);
                }
            }
        },
    };
    return (react_1.default.createElement("div", { style: { position: "relative", overflow: "auto" } },
        react_1.default.createElement("div", tslib_1.__assign({ ref: setBodyMaskRef }, maskDragEventHandlers, { style: {
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                width: "100px",
                zIndex: 1000,
                display: "none",
            } })),
        react_1.default.createElement("div", { ref: setBodyLineRef, style: {
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                width: "2px",
                zIndex: 500,
                display: "none",
            } }),
        react_1.default.cloneElement(body, {
            ref: merge_refs_1.mergeRefs(setBodyRef, body.ref, ref, bodyRef),
        })));
});
DraggableTable.displayName = "DraggableTable";
//# sourceMappingURL=DraggableTable.js.map